export default {
  apiKey: "AIzaSyDc5nRNcr_H5Q1kkH0dx8xVffhRdXqJubs",
  authDomain: "logintest-1c7c6.firebaseapp.com",
  databaseURL: "https://logintest-1c7c6.firebaseio.com",
  projectId: "logintest-1c7c6",
  storageBucket: "logintest-1c7c6.appspot.com",
  messagingSenderId: "594688412019"
}